import { render } from "./cabinetTimeBusyness.vue?vue&type=template&id=bfc0bb8c&class=mt-4"
import script from "./cabinetTimeBusyness.vue?vue&type=script&lang=js"
export * from "./cabinetTimeBusyness.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__